export default __webpack_public_path__ + "static/media/emenu-logo.51c284f1.jpg";